import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupRestrictedActionsContentProps } from './msg-group-restricted-actions-content';
import { MsgGroupRestrictedActionsContent } from './msg-group-restricted-actions-content';

export interface MsgGroupRestrictedActionsProps extends MsgGroupRestrictedActionsContentProps {}

export const MsgGroupRestrictedActions = memo(function MsgGroupRestrictedActions({
  message,
}: MsgGroupRestrictedActionsProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupRestrictedActionsContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
